import {api} from "@/api/client";
import {type AuthUser, useLandingAuth} from "@/state/authStore";

interface AuthSessionResponse {
  access_token: string;
  refresh_token: string;
  user: AuthUser;
}

interface MeResponse extends AuthUser {
  subscription_summary: { status: string };
  referrer_display_name?: string | null;
  has_referral_binding?: boolean;
}

export function exchangeWebHandoff(handoffCode: string) {
  return api<AuthSessionResponse>("/auth/web-handoff/exchange", {
    method: "POST",
    json: { handoff_code: handoffCode },
    auth: false,
  }).then((data) => {
    useLandingAuth.getState().setSession({
      accessToken: data.access_token,
      refreshToken: data.refresh_token,
      user: data.user,
    });
    return data;
  });
}

export function updateMe(body: { email?: string; phone_number?: string }) {
  return api<MeResponse>("/auth/me", {
    method: "PATCH",
    json: body,
  }).then((data) => {
    const { subscription_summary: _, ...user } = data;
    const { accessToken, refreshToken } = useLandingAuth.getState();
    if (accessToken && refreshToken) {
      useLandingAuth.getState().setSession({
        accessToken,
        refreshToken,
        user,
      });
    }
    return data;
  });
}

export function getMe() {
  return api<MeResponse>("/auth/me").then((data) => {
    const { subscription_summary: _, ...user } = data;
    const { accessToken, refreshToken } = useLandingAuth.getState();
    if (accessToken && refreshToken) {
      useLandingAuth.getState().setSession({
        accessToken,
        refreshToken,
        user,
      });
    }
    return data;
  });
}
